var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(-0.500000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7190453,12.526806 L14.7190453,12.526806 C14.7536013,12.8028393 14.5578454,13.0546217 14.2818121,13.0891778 C14.2609459,13.09179 14.2399366,13.0930929 14.2189076,13.0930789 L0.892649313,13.0842108 C0.614461489,13.0840257 0.389095772,12.8583599 0.389280894,12.580172 C0.389294887,12.5591432 0.39062575,12.5381358 0.393265669,12.5172733 C0.847113244,8.93064962 3.90889251,6.21234566 7.55555556,6.21234566 C11.2057699,6.21234566 14.2694977,8.93582913 14.7190453,12.526806 Z",
    id: "Oval-3",
    fill: "#3A5BA2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55555556,7.21975311 C4.61307346,7.21975311 2.11274459,9.27710865 1.49116555,12.0772015 L13.6217336,12.0852738 C13.0032253,9.28130885 10.5011048,7.21975311 7.55555556,7.21975311 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-9",
    stroke: "#3A5BA2",
    fill: "#FFFFFF",
    cx: 7.55555556,
    cy: 3.35802469,
    r: 3.35802469
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Glyphs/Time-Copy",
    transform: "translate(8.333333, 8.493827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_1232957_cc",
    transform: "translate(0.222222, 0.222222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    fill: "#3A5BA2",
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,6.95930233 C5.40465116,6.95930233 6.95930233,5.40465116 6.95930233,3.5 C6.95930233,1.59534884 5.40465116,0.0406976744 3.5,0.0406976744 C1.59534884,0.0406976744 0.0406976744,1.59534884 0.0406976744,3.5 C0.0406976744,5.40465116 1.59534884,6.95930233 3.5,6.95930233 Z M3.5,0.36627907 C5.2255814,0.36627907 6.63372093,1.7744186 6.63372093,3.5 C6.63372093,5.2255814 5.2255814,6.63372093 3.5,6.63372093 C1.7744186,6.63372093 0.36627907,5.2255814 0.36627907,3.5 C0.36627907,1.7744186 1.7744186,0.36627907 3.5,0.36627907 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57325581,3.6872093 L3.6627907,3.54069767 L3.6627907,1.88372093 C3.6627907,1.79381411 3.58990682,1.72093023 3.5,1.72093023 L3.5,1.72093023 C3.41009318,1.72093023 3.3372093,1.79381411 3.3372093,1.88372093 L3.3372093,3.44302326 L2.46951693,4.10845634 C2.39405734,4.16632628 2.37026287,4.26959551 2.4127907,4.35465116 L2.4127907,4.35465116 C2.44658544,4.42224064 2.52877359,4.44963669 2.59636307,4.41584195 C2.60366994,4.41218852 2.61063494,4.40788803 2.61717459,4.40299203 L3.57325581,3.6872093 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerified);
export default __webpack_public_path__ + "static/media/notVerified.50cf35ef8cd7dfcebc868fdcbaabd021.svg";
export { ForwardRef as ReactComponent };